export const earn = {
    jdzb: "コインを簡単に獲得",
    jryd: "財政は賢明であり、私たちは一緒に進歩することができます。",
    jrbk: "Biking に参加してコインを簡単に獲得し、無制限のイノベーションでデジタル資産の利点を最大限に活用してください。",
    zbz: "コインを稼ぐ",
    ljsy: "累計収入",
    zrsy: "昨日の収益",
    hq: "現在",
    cknh: "参照年換算",
    sqjd: "サブスクリプションの進行状況",
    sg: "サブスクリプション",
    qbcp: "すべての製品",
    cz: "リセット",
    qx: "用語",
    question1: "1. お金を稼ぐとは何ですか?",
    question1_text: "コインを獲得することは、ユーザーがさまざまな通貨保有商品の機会を発見できるようにするために、BIKINGによって作成されたワンストップ サービス プラットフォームです。現在、コインを獲得する簡単な方法はYubibao (いつでも入金および引き出し) ですが、さらに多くの商品が利用可能になります。ユーザーに幅広い製品の選択肢を提供するために、将来的に発売される予定です。",
    question2: "2. 基準年換算とは何ですか?",
    question2_text: "現在、トークンの獲得による収入は、入金されたトークンの利息です。 基準年率は、入金されたトークンの利息の年率です。たとえば、製品の最初の 1,000U は 12% の基準年率に基づき、最初の 1,000U を超える最初の 1,000U は 12% の基準年率に基づきます。利子の合計基準年率は 14% です。",
    question3: "3. 利息の発生・決済はいつから始まりますか?",
    question3_text: "異なる商品を購読する場合、利息の発生/決済時間は異なる場合があります。現在のUSDTの毎日の利息ベースの単純な収益を例として考えてみましょう、USDT の現在の商品を購入した翌日の午前 2 時 (UTC+8) に利息が発生します。午前 5 時 (UTC+8)、時刻 T+1 (つまり、購入時刻 T+2) に、翌日の決済の前の日の利息が発行されます。",
    question4: "4. 残りの投資はいくらですか?",
    question4_text: "残りの投資額は、まだ購読できる金融商品の金額です<br/>残りの投資額 = 商品購入総額 - あなたが購読している金額",
    xzmbfs: "入金/購入方法を選択します",
    nhsyl: "年換算収益率と期間:",
    sl: "数量",
    qitou: "投資を開始する",
    max: "最大",
    kzcsl: "これは資本口座から送金できる金額です",
    sykt: "残りは投資可能",
    syktsl: "残りの投資金額は、まだ購読できる金額です",
    syktsx: "残りの投資額 = 商品購入総額 - 購読した数量 (個別の投資制限 {金額}{コイン} を超えない)",
    jlgz: "報酬ルール",
    jd1: "ラダー 1: 最初の {金額}{コイン}",
    ptjl: "プラットフォーム報酬",
    jd2: "ラダー 2: 最初の {amount}{coin} より大きい",
    jd3: "ラダー 3: {amount}{coin} より大きい",
    jd22:"ラダー ",
    grsgsx: "個人購読の上限は {amount}{coin} です",
    gz: "ルール",
    sgsj: "購読時間",
    xianzai: "今",
    qxsj: "利息開始時刻",
    lxrz: "利息が記録されています",
    c2c: "C2C 購入コイン",
    lhxz: "柔軟な選択肢、より良い価格",
    lcjd: "シンプルなプロセス、迅速なトランザクション",
    crszhb: "ウォレットまたは取引所からデジタル通貨を入金",
    zcsl: "資産数量",
    dzsy: "収益を受け取りました",
    lcxx: "財務管理情報",
    zt: "ステータス",
    sh:"償還",
    sgje: "サブスクリプション金額",
    sgzj: "サブスクリプション資金の最初の {amount}{coin} は、{value}% の年間ボーナスを獲得できます",
    dyklqje: "{amount}{coin} を超える人は、{value}% の年間報酬を獲得できます",
    grsged: "個人のサブスクリプション金額は {amount}～{amoun2}{coin} です",
    shsl: "引き換え数量",
    srshsl: "償還金額を入力してください",
    ksh: "引き換え可能:",
    haode: "わかりました",
    zcsg: "もう一度購読してください",
    sjdzsl: "実際に受け取った数量",
    shsj: "引き換え時間",
    jssj: "決済時間",
    sgcg: "サブスクリプションが成功しました",
    shcg: "償還が成功しました",
    dq: "定期的に",
    yjsdd: "決済済み注文",
    jyjl: "取引記録",
    hqjdzb: "現在の入金で簡単にコインを獲得",
    sy: "利益",
    wwc: "未完了",
    xmlx: "プロジェクト タイプ",
    hqjdzbcp: "当座預金で簡単にお金を稼ぎます。バイキングが作った安全な金融商品です。24時間入出金に対応しており、金利は時間単位で計算されます。",
    nh: "年換算",
    zhzchz: "アカウント資産の転送、シンプルかつ高速",
    qsrsl: "数量を入力してください",
    yjssymx: "決済済み収入の詳細",
    mx: "詳細",
    qwsmrz: "実名認証へ進む",
    jxwcsmrz: "1. このアクティビティは、実名認証を完了したユーザーのみが参加できます。各ユーザーは、このアクティビティに一度だけ参加できます。",
    dqcked: "2. 各ユーザーの定期預金額は{min}〜{max}{coin}で、満期時にシステムが自動的に口座に払い戻します",
    cpbntjsh: "3. この商品は事前に引き換えることはできません",
    anzh: "4. 製品をサブスクライブすると、合計プールが 0 になり、ボタンがグレー表示されます",
    smrzyh: "このアクティビティは実名認証を完了したユーザーのみが利用できます。",
    jxcjyc: "参加資格のあるユーザーは1回のみ参加できます",
    ygsy: "推定収益",
    scqx: "ロック期間",
    qixian: "{min}日目（合計{max}日）",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/earn/ja_JP.js